<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-main style="padding-top: 0rem">
      <div class="zj-layout-main-content scrollable">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="16rem"
        >
          <el-form-item
            label="任务名称"
            prop="taskName"
            style="display: inline-block"
          >
            <el-input
              v-model="ruleForm.taskName"
              style="width: 40rem"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责人" style="display: inline-block">
            <el-select
              style="width: 40rem"
              v-model="ruleForm.personId"
              v-bind:disabled="IsEdit"
              @change="handleCheckedChange"
            >
              <el-option-group
                v-for="group in UsersOptions"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="联系电话" style="display: inline-block">
            <el-input
              style="width: 40rem"
              v-model="ruleForm.mobileNo"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="计划响应时间" style="display: inline-block">
            <el-input-number
              :min="1"
              style="width: 35rem"
              v-model="ruleForm.responseMinute"
              controls-position="right"
              v-bind:disabled="IsEdit"
            ></el-input-number>
            <div style="display: inline-block; padding-left: 1.5rem">分钟</div>
          </el-form-item>
          <el-form-item
            label="任务描述"
            style="display: inline-block"
            prop="taskDesc"
          >
            <el-input
              type="textarea"
              style="width: 98rem"
              v-model="ruleForm.taskDesc"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="任务地址" style="display: inline-block">
            <el-input
              style="width: 98rem"
              v-model="ruleForm.taskAddress"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="经度"
            prop="longitude"
            style="display: inline-block"
          >
            <el-input
              v-model="ruleForm.longitude"
              style="width: 40rem"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="纬度"
            prop="latitude"
            style="display: inline-block"
          >
            <el-input
              v-model="ruleForm.latitude"
              style="width: 35rem"
              v-bind:disabled="IsEdit"
            ></el-input>
            <ZjLngLatSelect
              :point_lat="ruleForm.latitude"
              :point_lng="ruleForm.longitude"
              @onGotLngLat="onGotLngLat"
              :disabled="IsEdit"
              style="margin-left: 0.5rem"
            ></ZjLngLatSelect>
          </el-form-item>
          <el-form-item label="任务执行方式" style="display: inline-block">
            <el-radio-group
              v-model="ruleForm.taskExecuteMode"
              style="width: 98rem"
              v-bind:disabled="IsEdit"
            >
              <el-radio
                v-for="item in taskExecuteModeoptions"
                :key="item.code"
                :label="item.code"
                :value="item.code"
                >{{ item.value }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="任务设置">
            <div
              class="bgcolor"
              style="padding: 1rem 1rem; width: 98rem; height: 60rem"
            >
              <el-tabs class="task" v-model="activeName">
                <el-tab-pane
                  :key="item.code"
                  v-for="item in EmergencyTaskType"
                  :label="item.value"
                  :name="item.code"
                  :disabled="ruleForm.id && activeName != item.code ? true : false"
                >
                  <CommunicationSettingInfo
                    v-if="item.code == 1"
                    :ref="item.code"
                    :taskId="ruleForm.id"
                    :form="ruleForm"
                  />
                  <ComponentResourcesInfo
                    v-if="item.code == 2"
                    :ref="item.code"
                    :taskId="ruleForm.id"
                    :form="ruleForm"
                  />
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </zj-layout-main>
    <zj-layout-footer style="padding-bottom: 0rem">
      <div
        class="right"
        style="width: 134rem; text-align: center; padding: 0rem 0rem"
      >
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          v-show="IsEdit == false"
          >提交</el-button
        >
      </div>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import CommunicationSettingInfo from "./CommunicationSettingInfo";
import ComponentResourcesInfo from "./ResourcesSettingInfo";
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
const utils = ZJApp.ZJUtils;

import { getDictionary } from "@/api/src/emergency_common";
import { list } from "@/api/src/emergency_person";
import { submit, detail } from "@/api/src/emergency_plan_task";
export default {
  name: "ZjPlanTaskinfo",
  controller: "UI",
  action: "PlanTaskinfo",
  components: {
    CommunicationSettingInfo: CommunicationSettingInfo,
    ComponentResourcesInfo: ComponentResourcesInfo,
  },
  props: {
    planId: String,
    id: String,
    IsEditTask: String,
  },
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      UsersOptions: [],
      ChildUser: [],
      activeName: "",
      EmergencyTaskType: [],
      taskExecuteModeoptions: [],
      ruleForm: {
        planId: this.$props.planId,
        taskName: "",
        taskDesc: "",
        personId: "",
        mobileNo: "",
        responseMinute: 1,
        taskExecuteMode: "1",
        taskAddress: "",
        longitude: 0,
        latitude: 0,
        sms: null,
        broadcast: null,
        resouceList: null,
      },
      IsEdit: false,
      rules: {
        taskName: [{ required: true, message: "请输入任务名称" }],
        taskDesc: [{ required: true, message: "请输入任务描述" }],
      },
    };
  },
  created: function () {
    this.loading = true;
    this.loadingText = "加载中...";
    utils
      .waitAll([
        getDictionary('emergency_task_type'),
        getDictionary('task_execute_mode'),
        getDictionary('organization_type'),
        list({
          page:1,
          size:10000,
        }),
      ])
      .then((r) => {
        let data = r[0].data.records;
        if (data) {
          this.activeName = data[0].code;
          this.EmergencyTaskType = data;
        }
        this.taskExecuteModeoptions = r[1].data.records;
        this.GetUserData(r[2].data.records, r[3].data.records);
        this.loading = false;
        this.search();
        return r;
      })
      .catch((e) => {
        console.error(e);
        this.loading = false;
      });
    this.IsEdit = this.$props.IsEditTask;
  },
  methods: {
    GetUserData(Fatoption, Chiloption) {
      this.ChildUser = Chiloption;
      var userOpt = [];
      for (var i = 0; i < Fatoption.length; i++) {
        var item = Fatoption[i];
        var users = [];
        for (var j = 0; j < Chiloption.length; j++) {
          var user = Chiloption[j];
          if (user.belongDeptType == item.code) {
            users.push({ value: user.id, label: user.name });
          }
        }
        userOpt.push({
          label: item.value,
          options: users,
        });
      }
      this.UsersOptions = userOpt;
    },
    handleCheckedChange(value) {
      for (var j = 0; j < this.ChildUser.length; j++) {
        var user = this.ChildUser[j];
        if (user.id == value) {
          this.ruleForm.mobileNo = user.contactNo;
          break;
        }
      }
    },
    onGotLngLat(obj) {
      this.ruleForm.latitude = obj.lat;
      this.ruleForm.longitude = obj.lng;
    },
    search() {
      let objId = this.$props.id;
      if (objId) {
        this.loading = true;
        this.loadingText = "加载中...";
        detail(objId)
          .then((r) => {
            var data = r.data;
            if (data) {
              if(data.broadcast){
                data.broadcast.relationEquipmentIds = JSON.parse( data.broadcast.relationEquipmentIds )
              }
              if(data.resouceList && data.resouceList.length){
                this.activeName = this.EmergencyTaskType[1].code
              }else{
                 this.activeName = this.EmergencyTaskType[0].code
              }
              this.ruleForm = data;
            }
            this.loading = false;
          })
          .catch((e) => {
            console.error(e);
            this.loading = false;
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          console.error("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    },
    submit() {
      let ruleForm = JSON.parse(JSON.stringify(this.ruleForm))
      // ruleForm.resouceList =[]
      // this.EmergencyTaskType.map(parent =>{
      //   var parentRefs = this.$refs[parent.code];
      //   parentRefs.map(parentObj =>{
      //     parentObj.EmergencyTaskSubType.map(item =>{
      //       var itemRefs = parentObj.$refs[item.code];
      //       itemRefs.map(child =>{
      //           var taskinfo = child.Gettaskreceiver(); 
      //           console.log(taskinfo)
      //           if(parent.code == 1 && item.code == 'sms'){
      //             ruleForm.sms = taskinfo
      //           }else if(parent.code == 1 && item.code == 'broadcast'){
      //             taskinfo.relationEquipmentIds = JSON.stringify(taskinfo.relationEquipmentIds)
      //             ruleForm.broadcast = taskinfo
      //           }else if(parent.code == 2){
      //             ruleForm.resouceList = ruleForm.resouceList.concat(taskinfo)
      //           }
      //       })
      //     })
      //   })
      // })
      console.log(this.activeName)
      var parentRefs = this.$refs[this.activeName][0];
      console.log(parentRefs.activeName)
      var itemRefs = parentRefs.$refs[parentRefs.activeName][0];
      var taskinfo = itemRefs.Gettaskreceiver(); 
    
      if(this.activeName == 1 && parentRefs.activeName == 'sms'){
          ruleForm.sms = taskinfo
        }else if(this.activeName == 1 && parentRefs.activeName == 'broadcast'){
          taskinfo.relationEquipmentIds = JSON.stringify(taskinfo.relationEquipmentIds)
          ruleForm.broadcast = taskinfo
        }else if(this.activeName == 2){
          ruleForm.resouceList = taskinfo
        }
      ruleForm.longitude = parseFloat(ruleForm.longitude);
      ruleForm.latitude = parseFloat(ruleForm.latitude);
      ruleForm.latitude = parseFloat(ruleForm.latitude);
      ruleForm.resouceList = ruleForm.resouceList && ruleForm.resouceList.length == 0 ? null : ruleForm.resouceList
      this.loading = true;
      this.loadingText = "提交中...";
      submit(ruleForm)
        .then((r) => {
          r = r.code;
          this.$emit("backList", {});
          this.$message({
            type: "success",
            message: r == 0 ? "保存成功！" : "保存失败！",
          });
          this.loading = false;
        })
        .catch((e) => {
          console.error(e);
          this.loading = false;
        });
    },
    onBack() {
      this.$emit("backList", {});
    },
  },
};
</script>
